"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _quotasApi = _interopRequireDefault(require("../api/quotasApi"));

var _quotaActions = require("../actions/quotaActions");

var getQuotasEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _quotasApi.default.getQuotas,
  initiatingActionType: _quotaActions.QuotaActionTypes.GET_QUOTAS,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _quotaActions.receiveGetQuotas
}));
var saveQuotasEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _quotasApi.default.saveQuotas,
  initiatingActionType: _quotaActions.QuotaActionTypes.SAVE_QUOTAS,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _quotaActions.receiveSaveQuotas
}));
var deleteQuotasEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _quotasApi.default.deleteQuotas,
  initiatingActionType: _quotaActions.QuotaActionTypes.DELETE_QUOTAS,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _quotaActions.receiveDeleteQuotas
}));
var deleteQuotaRowsEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _quotasApi.default.deleteQuotaRows,
  initiatingActionType: _quotaActions.QuotaActionTypes.DELETE_QUOTA_ROWS,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _quotaActions.receiveDeleteQuotas
}));
var updateQuotasRowPipelineEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _quotasApi.default.updateQuotaRowPipeline,
  initiatingActionType: _quotaActions.QuotaActionTypes.UPDATE_QUOTA_ROW_PIPELINE,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _quotaActions.receiveSaveQuotas
}));
var addQuotaRowsEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _quotasApi.default.addQuotaRows,
  initiatingActionType: _quotaActions.QuotaActionTypes.ADD_QUOTA_ROWS,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _quotaActions.receiveSaveQuotas
}));

var _default = (0, _reduxObservable.combineEpics)(getQuotasEpic, saveQuotasEpic, deleteQuotasEpic, addQuotaRowsEpic, deleteQuotaRowsEpic, updateQuotasRowPipelineEpic);

exports.default = _default;
module.exports = exports.default;